import React from 'react'
import PropTypes from 'prop-types'
import { Box, Container, Notification, ThemeProvider } from '@deseretbook/react-ui'

/**
 * Flash message component for displaying flash errors and notifications.
 */
const FlashMessage = ({ messages }) => {
  if (!messages.length) {
    return null
  }

  return (
    <ThemeProvider>
      <Container>
        <Box paddingVertical={1}>
          {messages.map(({ type, title, content, id }) => (
            <Notification key={id} type={type} titleContent={title}>
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </Notification>
          ))}
        </Box>
      </Container>
    </ThemeProvider>
  )
}

FlashMessage.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object),
}

FlashMessage.defaultProps = {
  messages: [],
}

export default FlashMessage
